<template>
  <v-layout
    id="payments"
    mt-5
    mb-8
    ml-2
    wrap
  >
    <v-flex
      v-for="(g, i) in userGateways"
      :key="i"
      xs12
      md4
      pt-0
      pb-0
    >
      <v-card>
        <v-card-title>
          <v-img
            :src="g.logo"
            :lazy-src="g.logo"
            max-height="60"
            contain
          />
        </v-card-title>
        <v-divider class="mt-2 mb-4 " />
        <v-checkbox
          v-model="form.gateways"
          color="primary"
          :value="g.id"
        >
          <template
            v-slot:label
          >
            <span>
              <b>{{ g.name }}</b><br>
              <small>{{ g.description }}</small>
            </span>
          </template>
        </v-checkbox>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>

import USER_GATEWAYS from '@/graphql/queries/UserGateways.gql';

export default {
  name: 'WhiteLabelPaymentGateways',
  props: {
    editForm: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: {
        gateways: [],
      },
    };
  },
  watch: {
    editForm(value) {
      if (value) {
        this.form.gateways = []
        this.editForm.gateways.forEach(item => {
          this.form.gateways.push(item.id)
        })
      }
    },
  },
  apollo: {
    userGateways: {
      fetchPolicy: "network-only",
      query() {
        return USER_GATEWAYS;
      },
    },
  },
  methods: {
    save() {
      let form = {
        modules:  []
      }
      this.$emit('saveForm', this.form);
    }
  },
};
</script>

<style lang="scss">
#payments {
  .theme--light.v-card {
    border: 1px solid rgb(197, 197, 197)
  }
  .theme--dark.v-card {
    border: 1px solid rgba(149, 149, 149, 0.6);
  }
}
</style>
